"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Text = _interopRequireDefault(require("../Text"));
var _LoyaltyTier = _interopRequireDefault(require("../LoyaltyTier"));
var _Spinner = _interopRequireDefault(require("../Spinner"));
var _bigmemberLogininfo = require("./bigmember.logininfo.proptypes");
var _constant = require("./constant");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
const BigMemberDataContainer = _styledComponents.default.div.withConfig({
  displayName: "BigMemberLoginInfo__BigMemberDataContainer",
  componentId: "sc-u3klfw-0"
})(["background-color:", ";border-bottom:1px solid ", ";"], _ref => {
  let {
    theme,
    background
  } = _ref;
  return theme.backgroundColor[background];
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.colors.greyLight;
});
const BigMemberDataMenuContainer = _styledComponents.default.div.withConfig({
  displayName: "BigMemberLoginInfo__BigMemberDataMenuContainer",
  componentId: "sc-u3klfw-1"
})(["display:flex;justify-content:space-between;", ""], _ref3 => {
  let {
    theme
  } = _ref3;
  return (0, _styledComponents.css)(["padding:", " ", ";align-items:center;"], theme.space.XSmall, theme.space.standard);
});
const BigMemberDataMenu = /*#__PURE__*/_react.default.memo(_ref4 => {
  let {
    labelTextColor,
    valueTextColor,
    label,
    value,
    isLoyaltyTier,
    id,
    accessible,
    isBigPoint,
    customProperties
  } = _ref4;
  const getValue = () => {
    if (isLoyaltyTier) return /*#__PURE__*/_react.default.createElement(_LoyaltyTier.default, {
      loyaltyTier: value
    });
    if (value != null) {
      // checks for undefined or null, allows 0
      return /*#__PURE__*/_react.default.createElement(_Text.default, {
        type: _constant.DEFAULT_STYLE.SUB,
        color: valueTextColor,
        accessible: accessible,
        customProperties: customProperties
      }, value);
    }
    if (isBigPoint) return /*#__PURE__*/_react.default.createElement(_Spinner.default, {
      height: "22px",
      width: "22px"
    });
    return null;
  };
  return /*#__PURE__*/_react.default.createElement(BigMemberDataMenuContainer, {
    id: id
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    type: _constant.DEFAULT_STYLE.SUB,
    bold: true,
    color: labelTextColor,
    accessible: accessible
  }, label), getValue());
});
BigMemberDataMenu.propTypes = _bigmemberLogininfo.BigMemberDataMenuPropTypes.PropTypes;
const BigMemberLoginInfo = props => {
  const {
    data,
    bigmemberId,
    loyaltyTier,
    theme,
    background,
    labelTextColor,
    valueTextColor,
    bigPoints,
    accessible,
    customProperties,
    showBigLoyaltyPoints,
    creditBalance,
    showCreditBalance
  } = props;
  const themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  const tabIndex = !accessible ? '-1' : '0';
  const arr = [];
  if (data) {
    // forEach is not used because of performance issues of callbacks
    for (let i = 0; i < data.length; i += 1) {
      const key = "".concat(data[i].id);
      switch (data[i].id) {
        case _constant.ID_TYPE.BIG_MEMBER_ID:
          arr.push( /*#__PURE__*/_react.default.createElement(BigMemberDataMenu, {
            key: key,
            id: key,
            labelTextColor: labelTextColor,
            valueTextColor: valueTextColor,
            label: data[i].label,
            value: bigmemberId,
            tabIndex: tabIndex,
            isLoyaltyTier: false,
            accessible: accessible,
            isBigPoint: false
          }));
          break;
        case _constant.ID_TYPE.BIG_MEMBER_POINTS:
          // eslint-disable-next-line no-unused-expressions
          showBigLoyaltyPoints && arr.push( /*#__PURE__*/_react.default.createElement(BigMemberDataMenu, {
            key: key,
            id: key,
            labelTextColor: labelTextColor,
            valueTextColor: valueTextColor,
            label: data[i].label,
            value: bigPoints,
            tabIndex: tabIndex,
            isLoyaltyTier: false,
            isBigPoint: true,
            accessible: accessible,
            customProperties: {
              'data-qm-encrypt': true
            }
          }));
          break;
        case _constant.ID_TYPE.STATUS:
          arr.push( /*#__PURE__*/_react.default.createElement(BigMemberDataMenu, {
            key: key,
            id: key,
            labelTextColor: labelTextColor,
            valueTextColor: valueTextColor,
            label: data[i].label,
            value: loyaltyTier,
            tabIndex: tabIndex,
            accessible: accessible,
            isBigPoint: false,
            isLoyaltyTier: true
          }));
          break;
        case _constant.ID_TYPE.CREDIT:
          // eslint-disable-next-line no-unused-expressions
          showCreditBalance && arr.push( /*#__PURE__*/_react.default.createElement(BigMemberDataMenu, {
            key: key,
            id: key,
            labelTextColor: labelTextColor,
            valueTextColor: valueTextColor,
            label: data[i].label,
            value: creditBalance,
            tabIndex: tabIndex,
            isLoyaltyTier: false,
            accessible: accessible,
            isBigPoint: true
          }));
          break;
        default:
          break;
      }
    }
  }
  const getMain = () => {
    return /*#__PURE__*/_react.default.createElement(BigMemberDataContainer, (0, _extends2.default)({
      id: "big-member-login-info",
      theme: themeContext,
      tabIndex: tabIndex,
      background: background
    }, customProperties), arr);
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
BigMemberLoginInfo.propTypes = _bigmemberLogininfo.BigMemberLoginInfoProptypes.PropTypes;
BigMemberLoginInfo.defaultProps = _bigmemberLogininfo.BigMemberLoginInfoProptypes.DefaultProps;
var _default = exports.default = BigMemberLoginInfo;